<template>
    <div>
        <div :class="$style.wraper">
            <img v-if="tripImg" :class="$style.trip_img" :src="tripImg" alt="行程图" />

            <div :class="$style.trip_table_wrap">
                <el-scrollbar :view-style="{
                    maxHeight: maxHeight ? maxHeight : 'none'
                }">
                    <table :class="$style.trip_table">
                        <thead :class="$style.trip_table_head">
                            <tr>
                                <th class="w-18">天</th>
                                <th>停靠港口</th>
                                <th class=w-30>抵港时间</th>
                                <th class="w-30">离港时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tour, index) in limitTours" :key="[index, tour.day].join('-')">
                                <td :class="$style.trip_table_td">{{ tour.day > 0 ? tour.day : '-' }}</td>
                                <td :class="$style.trip_table_td">{{ tour.itinerary || '-' }}</td>
                                <td :class="$style.trip_table_td">{{ tour.arrive_time || '-' }}</td>
                                <td :class="$style.trip_table_td">{{ tour.depart_time || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </el-scrollbar>
            </div>
        </div>
        <div v-if="expandable && !expand && tours.length > 8" class="text-right mt-4">
            <button type="button" class="text-dark border border-current rounded-full py-1 px-3"
                @click="expand = true"><span>查看更多</span><i class="ml-1 ficon ficon-arrow-bottom"></i></button>
        </div>
    </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
    props: {
        tripImg: String,
        tours: {
            type: Array,
            default: () => []
        },
        expandable: {
            type: Boolean,
            default: true
        },
        maxHeight: String
    },
    data() {
        return {
            expand: false
        }
    },
    computed: {
        limitTours() {
            if (!this.expandable || this.expand || this.tours.length <= 8) {
                return this.tours;
            }
            return this.tours.slice(0, 8)
        }
    }
})
</script>
<style lang="scss" module>
.wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.trip_img {
  margin-right: 1rem;
  width: 22.5rem;
}
.trip_table {
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
}
.trip_table_wrap {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.trip_table_head {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
}
.trip_table_head th {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
}
.trip_table_td {
  border-bottom-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>
